import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';

export const retailerGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Roles come from the bank profile, which is fetched after login. Reading them
    // early would let a retailer through on a deep link or refresh.
    await authService.profileReady();

    if (authService.isRetailer) {
        if (state.url !== '/no-access') {
            router.navigate(['/no-access']);
        }
        return false;
    }

    return true;
};
